<template>
    <div class="formit-radio-wrap">
        <span v-for="(option, key) in selectOptions" :key="key">
            <label>
            <input
                ref="input"
                type="radio"
                :name="name"
                v-bind="attributes"
                :value="key"
                :checked="isSelected(key)"
                @input="handleInput"
                @change="handleChange"
                @focus="handleFocus"
                @blur="handleBlur"
            >
            {{option}}</label><br/>
        </span>
    </div>
</template>

<script>
import basefield from '../../mixins/basefield'

export default {
	name: 'formit-radio',
    mixins: [basefield],
    data() {
        return {
            checkedItems: []
        }
    },
    created() {
        this.checkedItems = this.currentValue
    },
    methods: {
        isSelected(option) {
            return this.currentValue.includes(option)
        },
    }
}
</script>



// WEBPACK FOOTER //
// node_modules/vue-formit-fields/src/components/radio/radio.vue